<template>
  <div
    id="pizza-chart"
    ref="pizzaChart"
    style="width: 50%; height: 400px;"
  ></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "Pizza",
  props: {
    data: {
      type: Array,
      required: true
    },
    darkmode: String
  },
  mounted() {
    this.initChart();
    this.$watch(
      "data",
      () => {
        this.updateChart();
      },
      { deep: true }
    );
    this.$watch(
      "darkmode",
      () => {
        this.updateChart();
      },
      { deep: true }
    );
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.pizzaChart);
      this.chart.setOption(this.getChartOption());
    },
    updateChart() {
      this.chart.setOption(this.getChartOption());
    },
    getChartOption() {
      return {
        title: {
          text: this.data?.title,
          left: "center",
          textStyle: {
            color: this.darkmode ? "#FFFFFF" : "#000000",
            fontWeight: "bold"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          textStyle: {
            color: this.darkmode ? "#FFFFFF" : "#000000",
          }
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: "50%",
            data: this.data.series,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            label: {
              formatter: "{b}: {c} ({d}%)",
              textStyle: {
                color: this.darkmode ? "#FFFFFF" : "#000000",
              }
            }
          }
        ]
      };
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scoped>
#pizza-chart {
  width: 100%;
  height: 100%;
}
</style>
